module.exports = __webpack_public_path__ + "static/media/arshipper-logo.ffa7c93d.png";